const AUTODESK_API_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/transfer`;

/**
 * Trigger Autodesk Docs Copy Files flow
 * Copies all files from source project/folder to destination project/folder recursively
 * Backend reads parameters from database using flowId
 * Matches pattern: AutodeskDocsToSharePoint, AutodeskBudgetToQBO, etc.
 * 
 * @param {Object} syncFlow - flow row (must contain instanceId)
 * @param {Array} masterConnectors - array of master connectors to find Autodesk Docs connector
 * @returns {Promise<any>}
 */
export const handleAutodeskDocsCopyFilesFlow = async (syncFlow, masterConnectors) => {
  try {
    const token = localStorage.getItem('token');
    const flowId = syncFlow?.instanceId || syncFlow?.masterFlowId || syncFlow?.sfl_mf_id;

    if (!flowId) {
      throw new Error('Instance ID is required to run this flow.');
    }

    // Match Data Point execution path: explicit runType and instance-aware flow id.
    const url = `${AUTODESK_API_URL}/autodesk-docs-copy-files?flowId=${encodeURIComponent(flowId)}&runType=Manual`;

    console.log('Calling copy-all-files API with flowId:', flowId);
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json',
    };
    // IMPORTANT: Do not send tenant headers like `db_name` / `TENANT_DB_PATH`.
    // They are blocked by CORS preflight allow-headers and prevent the request
    // from reaching the backend.

    const response = await fetch(url, {
      method: 'POST',
      headers,
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      const backendMessage =
        result?.message ||
        result?.error ||
        result?.details ||
        `${response.statusText}`;
      throw new Error(`API Error ${response.status}: ${backendMessage}`);
    }
    console.log('Copy files result:', result);

    if (result.error || result.status === 'error') {
      throw new Error(result.message || 'Copy operation failed');
    }

    return result;
  } catch (error) {
    console.error('Error in Autodesk Docs Copy Files flow:', error);
    throw error;
  }
};
